export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="#232323" />
    <path
      d="M6.99992 12.9933C6.44764 12.9933 5.99992 12.5455 5.99992 11.9933C5.99992 11.4804 6.38596 11.0578 6.8833 11L6.99992 10.9933L17 11C17.5523 11 18 11.4477 18 12C18 12.5129 17.614 12.9355 17.1166 12.9933L17 13L6.99992 12.9933Z"
      fill="white"
    />
  </svg>
);
